/* Sticky tab bar (sections/seatfit-sticky-tabs.liquid) + the page-wide in-page anchor resolver. Why a resolver: Shopify
 * ids every JSON-template section "shopify-section-template--<n>__<key>", <n> known only after the template is saved,
 * so "#pdp-13-reviews" matches nothing natively. One delegated listener maps a[href^="#pdp-"], a[href="#seatfit-reviews"]
 * (Shrine scroll buttons, the "3-Year Warranty" link...) to [id$="__<key>"], just under the header + bar. Active
 * tab = scroll spy like the reference page's: untabbed sections belong to the tab above them. Empty targets hide. */
(function () {
  'use strict';
  var ANCHORS = 'a[href^="#pdp-"], a[href="#seatfit-reviews"]';
  var DEEP_LINK = /^#(pdp-[A-Za-z0-9_-]+|seatfit-reviews)$/;
  var LINE_RATIO = 0.3, GAP = 8, ALIGN_MS = 15000;

  function resolveTarget(href) {
    var key = String(href || '').replace(/^#/, '');
    if (!/^[A-Za-z0-9_-]+$/.test(key)) return null;
    return document.getElementById(key) || document.querySelector('[id$="__' + key + '"]');
  }

  function isShown(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  // An "on scroll up" header hides while scrolling down, so its room depends on the jump direction.
  function headerRoom(goingUp) {
    var total = 0;
    document.querySelectorAll('sticky-header[data-sticky-type], sticky-announcement[data-sticky-type]').forEach(function (el) {
      var type = el.getAttribute('data-sticky-type');
      if (type === 'none' || (type === 'on-scroll-up' && !goingUp)) return;
      total += (el.closest('.shopify-section') || el).getBoundingClientRect().height;
    });
    return total;
  }

  function tabsRoom() { var bar = document.querySelector('seatfit-sticky-tabs'); return isShown(bar) ? bar.offsetHeight : 0; }

  // In-page jump buttons outside the bar (buy-box Features / Easy Install / Reviews row, links to #seatfit-reviews).
  // One whose target is hidden or empty (Reviews at 0 reviews) hides with it; a missing target hides only our own
  // keys (an app may insert its element later). Inline display:none because Shrine's display:flex beats [hidden].
  function jumpLinks() {
    return Array.prototype.filter.call(document.querySelectorAll('.scroll-button[href], ' + ANCHORS), function (a) {
      return !a.hasAttribute('data-sf-tab') && /^#[A-Za-z0-9_-]+$/.test(a.getAttribute('href') || '');
    }).map(function (a) { return { link: a, target: resolveTarget(a.getAttribute('href')) }; });
  }

  function refreshJumps(jumps) {
    (jumps || []).forEach(function (j) {
      var hide = j.target ? !isShown(j.target) : j.link.matches(ANCHORS);
      if (hide !== j.link.hidden) { j.link.hidden = hide; j.link.style.display = hide ? 'none' : ''; }
    });
  }

  // Scroll position that puts el just under the sticky header + tab bar (never past the page end).
  function destOf(el) {
    var y = window.pageYOffset;
    var top = el.getBoundingClientRect().top + y;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    return Math.max(0, Math.min(max, top - headerRoom(top < y) - tabsRoom() - GAP));
  }
  function scrollToTarget(el, instant) { window.scrollTo({ top: destOf(el), behavior: instant ? 'auto' : 'smooth' }); }
  function jumpTo(el) { try { scrollToTarget(el); } catch (err) { el.scrollIntoView(); } }
  // Modified clicks (new tab/window) keep the browser's own behaviour.
  function plainClick(e) { return !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey; }

  // Ad or email links may end in #pdp-13-reviews. Window 'load' waits for dozens of video players and posters
  // (37 s to never on phones), so jump as soon as the DOM is parsed (this file is deferred), then keep the target
  // in place while images and late styles above it still move it. Any input from the shopper stops that.
  function deepLink() {
    var hash = location.hash;
    if (!DEEP_LINK.test(hash)) return;
    var stop = false;
    var start = Date.now();
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (n) {
      window.addEventListener(n, function () { stop = true; }, { once: true, passive: true });
    });
    (function align() {
      if (stop || Date.now() - start > ALIGN_MS) return;
      try {
        var t = resolveTarget(hash);
        if (t && isShown(t) && Math.abs(destOf(t) - window.pageYOffset) > 2) scrollToTarget(t, true);
      } catch (e) { return; }
      setTimeout(align, 200);
    })();
  }

  window.SeatFitAnchors = window.SeatFitAnchors || { resolve: resolveTarget, scrollTo: scrollToTarget };

  // One page-wide listener even if the section renders twice (theme editor re-render).
  if (!window.__seatfitAnchorResolver) {
    window.__seatfitAnchorResolver = true;
    document.addEventListener('click', function (e) {
      var a = plainClick(e) && e.target && e.target.closest ? e.target.closest(ANCHORS) : null;
      var target = a ? resolveTarget(a.getAttribute('href')) : null;
      if (!target) return;
      // Native navigation would only add a dead hash to the URL, so it is always cancelled.
      e.preventDefault();
      if (isShown(target)) jumpTo(target);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deepLink); else deepLink();
  }

  if (!window.customElements || customElements.get('seatfit-sticky-tabs')) return;

  class SeatfitStickyTabs extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.sf-tabs__bar') || this;
      this.items = Array.prototype.map.call(this.querySelectorAll('[data-sf-tab]'), function (tab) {
        return { tab: tab, target: resolveTarget(tab.getAttribute('href')) };
      });
      this.jumps = jumpLinks();
      this.active = this.items.filter(function (it) { return it.tab.classList.contains('is-active'); })[0] || null;
      this.locked = false;
      ['onClick', 'onScroll', 'update', 'unlock'].forEach(function (k) { this[k] = this[k].bind(this); }, this);
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      // Without the observers the tabs still work as plain jump links.
      try { this.refreshVisibility(); this.watchTargets(); } catch (e) { if (window.console) console.warn('[seatfit-sticky-tabs]', e); }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.unlock();
      cancelAnimationFrame(this.raf);
      if (this.ro) this.ro.disconnect();
    }

    // Scrolls our own resolved target (keys without "pdp-" and plain ids work too) and holds the picked tab
    // while the smooth scroll passes other sections.
    onClick(e) {
      var tab = e.target.closest ? e.target.closest('[data-sf-tab]') : null;
      var item = tab && this.items.find(function (it) { return it.tab === tab; });
      if (!item || !item.target || !plainClick(e)) return;
      e.preventDefault();
      this.setActive(item);
      this.unlock(); // drops a previous click's timer and scrollend listener
      this.locked = true;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      window.addEventListener('scrollend', this.unlock, { once: true });
      this.lockTimer = setTimeout(this.unlock, 1500);
      jumpTo(item.target);
    }

    unlock() {
      this.locked = false;
      clearTimeout(this.lockTimer);
      window.removeEventListener('scrollend', this.unlock);
    }

    setActive(item) {
      if (!item || item === this.active) return;
      this.active = item;
      this.items.forEach(function (it) {
        it.tab.classList.toggle('is-active', it === item);
        if (it === item) it.tab.setAttribute('aria-current', 'true'); else it.tab.removeAttribute('aria-current');
      });
      // Phones: bring the active tab into view inside the sideways-scrolling bar, never the page.
      var bar = this.bar;
      if (bar.scrollWidth > bar.clientWidth + 1) {
        bar.scrollTo({ left: Math.max(0, item.tab.offsetLeft - (bar.clientWidth - item.tab.offsetWidth) / 2), behavior: 'smooth' });
      }
    }

    refreshVisibility() {
      var visible = this.items.filter(function (it) { it.tab.hidden = !isShown(it.target); return !it.tab.hidden; });
      refreshJumps(this.jumps);
      (this.closest('.shopify-section') || this).style.display = visible.length ? '' : 'none';
      if (this.active && this.active.tab.hidden) this.setActive(visible[0]);
      this.onScroll(); // sections above may have grown or collapsed, which moves every target
    }

    // Sections that hide or fill themselves later (reviews once its JSON is in) change size.
    watchTargets() {
      if (!window.ResizeObserver) return;
      var self = this;
      this.ro = new ResizeObserver(function () { self.refreshVisibility(); });
      this.items.concat(this.jumps || []).forEach(function (it) { if (it.target) self.ro.observe(it.target); });
    }

    // Last shown target whose top passed the line, else the first tab (the markup's start state).
    // At the page bottom the last target wins: a short last section may never reach the line.
    pick() {
      var shown = this.items.filter(function (it) { return it.target && !it.tab.hidden; });
      if (!shown.length) return null;
      var h = window.innerHeight || document.documentElement.clientHeight;
      if (window.pageYOffset + h >= document.documentElement.scrollHeight - 2) return shown[shown.length - 1];
      var hit = shown[0];
      shown.forEach(function (it) { if (it.target.getBoundingClientRect().top <= h * LINE_RATIO) hit = it; });
      return hit;
    }

    // Scroll events during a tab click's scroll are dropped, not deferred: its end never relights.
    onScroll() { if (!this.locked && !this.raf) this.raf = requestAnimationFrame(this.update); }
    update() { this.raf = 0; if (!this.locked) this.setActive(this.pick()); }
  }

  customElements.define('seatfit-sticky-tabs', SeatfitStickyTabs);
})();
